<template>
  <div class="ma-2 ml-3 site_content">
    <div class="flex s-bt a-center combo_section">
      <comboFarm
        @fromFarm="farmInfo"
      />
      <v-btn class="pause_btn" style="color:white !important;" @click="allStop()">
        전체 일시중지
      </v-btn>
    </div>

    <!--VMS 주기-->
    <div class="mt-2 flex a-center">
      <div class="time_text mr-2" style="letter-spacing: -1px;">
        전화 알림주기 *
      </div>
      <v-text-field
        v-model="voice_term"
        ref="voice_term" 
        outlined
        suffix="분"
        dense
        hide-details
        type="number"
        class="setting_textbox no_data_textbox"
      />
      <v-btn class="ml-2 pause_btn" 
        @click="voiceSave()"
        :loading="termloading"
        style="color:white !important; height:35px !important;">
        저장
      </v-btn>
    </div>
  

    <div class="alert_container">
      <div v-for="(item, i) in items" :key="i" class="farm_section">
        <div v-for="(room, r) in item.rooms" :key="r" class="room_section">
          <div class="room_name">
            {{ room.room.name }}
            <v-btn @click=save(i,r) v-if="room.showBtn" class="alert_saveBtn" style="color:white!important"> 저장 </v-btn>
          </div>

          <!--범위 초과 알림-->
          <div class="range_section">
            <div class="flex s-bt title_section"> 
              <div class="title_text">📊 범위 초과 알림</div>
              <v-switch
                v-model="room.setup.range_alert.on"
                hide-details
                inset
                dense
                @change="checkValue(i, r)"
                class="switch">

              </v-switch>
            </div>

            <div class="setting_section">
              <div v-show="room.setup.range_alert.on !== false">
                <div class="setting_section">
                  <div
                    v-for="(value, key) in room.setup.range_alert.range"
                    :key="key"
                    class="range_row"
                  >
                    <div class="row_header flex mt-1">
                      <span class="value_title">{{ label[key] }}</span>
                      <v-switch
                        v-model="value.on"
                        hide-details
                        inset
                        dense
                        class="switch mr-2"
                        @change="checkValue(i, r)"
                      />
                      <v-text-field
                        v-model="value.min"
                        :disabled="value.on == false"
                        :suffix="`${unit[key]}`"
                        ref="value_min"
                        outlined
                        rounded
                        dense
                        hide-details
                        type="number"
                        @input="checkValue(i, r)"
                        class="range_input setting_textbox"
                      />
                      <span class="ml-1 mr-1"> ~ </span>
                      <v-text-field
                        v-model="value.max"
                        :disabled="value.on == false"
                        outlined
                        :suffix="`${unit[key]}`"
                        ref="value_max"
                        dense
                        hide-details
                        type="number"
                        @input="checkValue(i, r)"
                        class="range_input setting_textbox"
                      />
                    </div>
                  </div>

                  <!--알림주기-->
                  <div class="mt-1 mb-1 pa-2 flex a-center" style="justify-content: center;">
                    <div class="time_text mr-3">알림주기</div>
                    <v-text-field
                      v-model="room.setup.range_alert.term"
                      :disabled="room.setup.range_alert.on == false"
                      ref="range_alert_term"
                      outlined
                      suffix="분"
                      dense
                      hide-details
                      type="number"
                      @input="checkValue(i, r)"
                      class="setting_textbox"
                    />

                    <div class="time_text mr-3 ml-5">
                      시간당 최대<br/> 알림 수
                    </div>
                    <v-text-field
                      v-model="room.setup.range_alert.max_count_hour"
                      :disabled="room.setup.range_alert.on == false"
                      ref="range_alert_count"
                      outlined
                      suffix="회"
                      dense
                      hide-details
                      type="number"
                      @input="checkValue(i, r)"
                      class="setting_textbox"
                    />
                  </div>

                  <div class="time_info">
                    1시간 동안 이 개수를 초과하는 알림은 보내지 않습니다.
                  </div>

                  <!--수신방식-->
                  <div class="row_header flex mt-1" style="justify-content: space-around;">
                    <span class="value_title" style="width:150px;">수신방식</span>
                    <v-checkbox
                      v-model="room.setup.range_alert.way.sms"
                      ref="range_way_sms"
                      color="#005B96"
                      label="문자"
                      hide-details
                      class="checkbox"
                      @change="checkValue(i, r)"
                    ></v-checkbox>

                    <v-checkbox
                      v-model="room.setup.range_alert.way.voice"
                      color="#005B96"
                      ref="range_way_voice"
                      label="전화"
                      hide-details
                      class="checkbox"
                      @change="checkValue(i, r)"
                    ></v-checkbox>
                  </div>
                </div>
             </div>
            </div>
          </div>

          <!--수신이상 알림-->
          <div class="range_section mt-2">
            <div class="flex s-bt title_section" style="background-color: #FFF7ED ;"> 
              <div class="title_text">📶 수신이상 알림</div>
              <v-switch
                v-model="room.setup.rx_alert.on"
                hide-details
                inset
                dense
                class="switch"
                @change="checkValue(i, r)">

              </v-switch>
            </div>

            <div class="setting_section">
              <div v-show="room.setup.rx_alert.on !== false">
                <div class="row_header flex">
                  <span class="value_title mr-3 ml-2">데이터 미수신 </span>
                  <v-text-field
                      v-model="room.setup.rx_alert.elapsed"
                      :disabled="room.setup.rx_alert.on == false"
                      ref="rx_alert_elapsed"
                      outlined
                      suffix="분"
                      dense
                      hide-details
                      type="number"
                      @input="checkValue(i, r)"
                      class="setting_textbox no_data_textbox "
                    />
                  <span class="gray ml-3 mr-1">분 이상 수신이 없을 때 알림</span>
                </div>

                <!--알림주기-->
                <div class="mt-1 mb-1 pa-2 flex a-center" style="justify-content: center;">
                    <div class="time_text mr-3">알림주기</div>
                    <v-text-field
                      v-model="room.setup.rx_alert.term"
                      :disabled="room.setup.rx_alert.on == false"
                      ref="rx_alert_term"
                      outlined
                      suffix="분"
                      dense
                      hide-details
                      type="number"
                      @input="checkValue(i, r)"
                      class="setting_textbox"
                    />

                    <div class="time_text mr-3 ml-5">
                      시간당 최대<br/> 알림 수
                    </div>
                    <v-text-field
                      v-model="room.setup.rx_alert.max_count_hour"
                      :disabled="room.setup.rx_alert.on == false"
                      outlined
                      ref="rx_alert_count"
                      suffix="회"
                      dense
                      hide-details
                      type="number"
                      @input="checkValue(i, r)"
                      class="setting_textbox"
                    />
                  </div>

                  <div class="time_info">
                    1시간 동안 이 개수를 초과하는 알림은 보내지 않습니다.
                  </div>

                  <!--수신방식-->
                  <div class="row_header flex mt-1" style="justify-content: space-around;">
                    <span class="value_title" style="width:150px;">수신방식</span>
                    <v-checkbox
                      v-model="room.setup.rx_alert.way.sms"
                      ref="rx_way_sms"
                      color="#005B96"
                      label="문자"
                      hide-details
                      class="checkbox"
                      @change="checkValue(i, r)"
                    ></v-checkbox>

                    <v-checkbox
                      v-model="room.setup.rx_alert.way.voice"
                      color="#005B96"
                      ref="rx_way_voices"
                      label="전화"
                      hide-details
                      class="checkbox"
                      @change="checkValue(i, r)"
                    ></v-checkbox>
                  </div>
              </div>
            </div>
          </div>
          <!--로그-->
          <div class="gray time_text" style="text-align: center;" >
            {{ room.regdate }} {{ room.reguser }}
          </div>
        </div>
      </div>
    </div>
  </div>
 
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import comboFarm from "@/components/combo/farm.vue";


export default {
  name: "AlertSet",
  components:{
    comboFarm
  },
  computed: {
    validKeys() {
      return ['temp', 'hum', 'nh3', 'co2', 'h2s'];
    }
  },
  data: () => ({  
    farmData: { company: {}, farm: {} },
    voice_term:'',

    loading: false,
    loadingSave : false,
    termloading:false,

    items:[],

    label: { temp: '온도', hum: '습도', nh3: '암모니아', co2: '이산화탄소', h2s:'황화수소' },
    unit:  { temp: '℃', hum: '%', nh3: 'ppm', co2: 'ppm', h2s:'ppm' },

    roomSetup:{},


  }),
  
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 


  },
  methods:{
    farmInfo(data){
      // console.log(data)
      this.farmData = data;
      this.refresh();
    },
    checkValue(i, r) {
      const room = this.items[i].rooms[r];
      const showBtn = room.setup.range_alert || room.setup.rx_alert ;
      this.$set(this.items[i].rooms[r], 'showBtn', !!showBtn);
    },
    refresh(){
      this.$store.commit("resMessage","");
      this.loading = true;

      Apis.listAlertSetupOfFarm2025({
        code: this.farmData.farm.code,
      } ,(res) => {  // 정상처리
        this.items = res.data;

        if(res.data.length > 1) {
          this.voice_term = this.items[0].voice_term;
        }
        
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("listAlertSetupOfFarm2025 호출 오류",err);

        this.loading = false;
      })
      this.changed = false;
    },
    checkData(){
      for (let i = 0; i < this.items.length; i++) {
        for (let r = 0; r < this.items[i].rooms.length; r++) {
          let room = this.items[i].rooms[r];

          if (room.setup.range_alert.on) {
            // 센서 켜져있는지 체크
            const RangeCheck = Object.values(room.setup.range_alert.range).some(range => range.on);
            if (!RangeCheck) {
              return "범위 초과 알림을 사용하려면 최소 하나의 측정 항목을 선택하세요.";
            }

            if (!room.setup.range_alert.way.sms && !room.setup.range_alert.way.voice) {
              return "범위초과 허용 시 수신 방식 중 하나를 무조건 선택하세요.";
            }
            if (room.setup.range_alert.term < 0 ){
              this.$refs.range_alert_term[r].focus();
              return "양수를 입력하세요";
            }
            if (!room.setup.range_alert.term){
              this.$refs.range_alert_term[r].focus();
              return "알림주기를 입력하세요";
            }
            if (room.setup.range_alert.max_count_hour < 0 ){
              this.$refs.range_alert_count[r].focus();
              return "양수를 입력하세요";
            }
            if (!room.setup.range_alert.max_count_hour){
              this.$refs.range_alert_count[r].focus();
              return "시간 최대 알림 수를 입력하세요";
            }
          }
          
          if (room.setup.rx_alert.on) {
            if (!room.setup.rx_alert.way.sms && !room.setup.rx_alert.way.voice) {
              return "수신이상 알림 수신 방식 중 하나를 선택하세요.";
            }
            if (room.setup.rx_alert.elapsed < 0 ){
              this.$refs.rx_alert_elapsed[r].focus();
              return "양수를 입력하세요";
            }
            if (!room.setup.rx_alert.elapsed){
              this.$refs.rx_alert_elapsed[r].focus();
              return "데이터 미수신 주기를 입력하세요";
            }
            if (room.setup.rx_alert.term < 0 ){
              this.$refs.rx_alert_term[r].focus();
              return "양수를 입력하세요";
            }
            if (!room.setup.rx_alert.term){
              this.$refs.rx_alert_term[r].focus();
              return "알림주기를 입력하세요";
            }
            if (room.setup.rx_alert.max_count_hour < 0 ){
              this.$refs.rx_alert_count[r].focus();
              return "양수를 입력하세요";
            }
            if (!room.setup.rx_alert.max_count_hour){
              this.$refs.rx_alert_count[r].focus();
              return "시간 최대 알림 수를 입력하세요";
            }
          }
        }
      }
    },
    save(i,r){
      this.$store.commit("resMessage","");
      let msgCheckdata = this.checkData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        return;
      }
      this.loadingSave = true;

      const room = this.items[i].rooms[r];
  
      // setup 객체 구성
      const setup = {
        range_alert: {
          on: room.setup.range_alert.on,
          range: { ...room.setup.range_alert.range }, 
          way: { ...room.setup.range_alert.way },
          term: room.setup.range_alert.term,
          max_count_hour: room.setup.range_alert.max_count_hour
        },
        rx_alert: {
          on: room.setup.rx_alert.on,
          elapsed: room.setup.rx_alert.elapsed,
          way: { ...room.setup.rx_alert.way },
          term: room.setup.rx_alert.term,
          max_count_hour: room.setup.rx_alert.max_count_hour
        }
      };

      const params = {
        room_cd: room.room.code, 
        setup: setup
      };

      Apis.saveAlertSetup2025({
      "room_cd" : params.room_cd,
      "setup" : params.setup
      },(res) => {
        // console.log(res)
        if (res.result) {
          this.$store.commit("resMessage",res.message);
          this.loadingSave = false;
          this.$set(this.items[i].rooms[r], 'showBtn', false);
          // this.showBtn = false;

          this.refresh();

        } else {
          this.loadingSave = false;
          console.log("저장 오류",res.message)
        }
      }).catch( (err) => {  // API 오류 처리
          this.loadingSave = false;
          console.log("saveAlertSetupOfRoom API 호출 오류",err)
          alert(err);
      })

    },
    voicecheckData(){
      if (!this.voice_term) {
        this.$refs.voice_term.focus();
        return "전화 알림 주기를 입력해주세요.";
      }
      if (this.voice_term < 1) {
        this.$refs.voice_term.focus();
        return "전화 알림 주기는 0분 이상을 입력해주세요.";
      }
    },
    voiceSave(){
      this.$store.commit("resMessage","");
      this.termloading = true;

      let msgCheckdata = this.voicecheckData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        return;
      }

      Apis.saveAlertVoiceSetup({
        "farm_cd" : this.farmData.farm.code,
        "term" : this.voice_term
      },(res) => {
        if (res.result) {
          this.$store.commit("resMessage",res.message);
          this.termloading = false;

          this.refresh();

        } else {
          this.termloading = false;
          console.log("저장 오류",res.message)
        }
      }).catch( (err) => {  // API 오류 처리
          this.termloading = false;
          console.log("saveAlertVoiceSetup API 호출 오류",err)
          alert(err);
      })
    }, 
    allStop(){
      if (!confirm('전체 알림을 일시정지하고 저장하시겠습니까?')) {
        return;
      }

      this.loadingSave = true;

      for (let i = 0; i < this.items.length; i++) {
        for (let r = 0; r < this.items[i].rooms.length; r++) {
          const room = this.items[i].rooms[r];

          Apis.saveAlertSetup2025({
            "room_cd": room.room.code,
            "setup": {
              "range_alert": {
                "on": false,
                "range": { ...room.setup.range_alert.range },
                "way": { ...room.setup.range_alert.way },
                "term": room.setup.range_alert.term,
                "max_count_hour": room.setup.range_alert.max_count_hour
              },
              "rx_alert": {
                "on": false,
                "elapsed": room.setup.rx_alert.elapsed,
                "way": { ...room.setup.rx_alert.way },
                "term": room.setup.rx_alert.term,
                "max_count_hour": room.setup.rx_alert.max_count_hour
              }
            }
          },(res) => {
            if (res.result) {
              this.$store.commit("resMessage",res.message);
              this.loadingSave = false;
              this.$set(this.items[i].rooms[r], 'showBtn', false);
              // this.showBtn = false;

              this.refresh();

            } else {
              this.loadingSave = false;
              console.log("저장 오류",res.message)
            }
          }).catch( (err) => {  // API 오류 처리
              this.loadingSave = false;
              console.log("saveAlertSetupOfRoom API 호출 오류",err)
              alert(err);
          })

        }
      }

    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';

.site_content{
  width: 90% !important;
  max-width: 1500px !important;
  margin: 15px auto !important;
}
.alert_container, .combo_section{
  margin-top:10px;
  width: 90% !important;
  max-width: 1500px !important;
}
.farm_section{
  display: grid;
  grid-template-columns: repeat(3, 1fr); 
  gap: 10px 5px;
  
  margin-top: 10px;
}
.room_section{
  padding:10px;
  border-radius: 10px;

  background: #FFFFFF;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
}
.room_name{
  color:$main-color;
  font-weight: 600;
  letter-spacing: -0.75px;
  font-size:1.1rem;

  display: flex;
  justify-content: space-between;
  align-items: center;
}
.alert_saveBtn{
  background-color: $main-color !important;
  border-radius: 10px;
  height:30px !important;
}
.range_section{
  margin-top:5px;
  border: 1px solid #EBECEF;
  border-radius: 20px;
}
.title_section{
  background-color: #F5F9FE;
  padding:10px;
  border: 1px solid #EBECEF;
  border-radius: 20px 20px 0 0;
}
.switch{
  margin-top:-3px;
  // height:1px;
}
.row_header{
  height:50px;
  align-items: center;
  border: 1px solid #eeeeee;
  border-radius: 10px ;
}
.range_input{
  max-width:120px;
}
.setting_section{
  padding:5px;
}
.title_text, .value_title{
  color:$main-color;
  font-weight:600;
  letter-spacing: -1px;
}
.value_title{
  width:80px !important;
  text-align: center;
}
.pause_btn{
  background-color: $main-color !important;
  height: 40px !important;
  color: white !important;
  border-radius: 15px !important;
}
.setting_textbox, .time_imput{
  border-radius: 10px;
  border:1px solid #ededed;
  width:90px;
}
.gray{
  color:#a2a2a2;
  font-weight: 600;
}

.time_text{
  font-size:0.9rem;
  text-align: center;
}
.time_info{
  font-size:0.75rem;
  color:#9c9c9c;
  text-align: right;
  margin-top:-10px;
  letter-spacing: -0.75px;
}
.no_data_textbox{
  max-width:120px !important;
}
::v-deep .v-text-field__slot{
  margin-left:-5px !important;
  min-width:60px !important;
}
::v-deep .switch > .v-input__control > .v-input__slot{
  background-color: transparent !important;
}
::v-deep .v-text-field__suffix{
  letter-spacing: -0.75px;
  font-size:12px !important;
}
::v-deep .checkbox{
  margin-top:-7px;
  // height:0px !important;
}
@media screen and (max-width: 768px){
  .site_content{
    width:90% !important;
  }
  .farm_section{
    grid-template-columns: repeat(1, 1fr); 
    gap:5px;
    margin-top: 10px;
  }
  .time_text{
    font-size:0.7rem;
  }
  .time_info{
    font-size:0.75rem;
  }
  .gray{
    font-size:0.75rem;
  }
  .pause_btn{
    width:85px !important;
    margin-top:5px;
    margin-left:10px;
  }
  .setting_textbox, .time_imput{
    width:80px;
  }
  .range_input{
    width:80px;
  }
  .no_data_textbox{
    max-width:75px !important;
  }
  ::v-deep .v-text-field__slot{
    margin-left:-5px !important;
    min-width:55px !important;
  }
  .room_section{
    min-width:360px !important;
  }
}


</style>